<template>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialogConfirm')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialogConfirm"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogConfirm()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap justify-space-between>
            <v-flex xs12>
			  <div v-if="!loadingRes && !contentDialogRes.length" v-html="contentDialogConfirm"></div>
			  <div v-else class="tf_loading_url">
			  	<div class="tf_contentLoading">
			  		<div v-if="loadingRes" class="text-xs-center">
			  			<v-progress-circular
			  				:rotate="-90"
			  				:size="120"
			  				:width="8"
			  				:value="loadingValue"
			  				color="primary"
			  			>
			  				{{ loadingValue }} %
			  			</v-progress-circular>
			  		</div>
			  		<div v-if="contentDialogRes.length" class="tf_contentLoadingTxt">
			  			<div class="contentLoading" v-html="contentDialogRes"></div>
			  		</div>
			  	</div>
			  </div>
            </v-flex>
            <v-flex xs12 v-if="!contentDialogRes.length">
              <p><v-spacer></v-spacer></p>
              <v-divider ></v-divider>
              <p><v-spacer></v-spacer></p>
            </v-flex>
            <!-- Actions pour la selection -->
            <v-flex xs12 v-if="!contentDialogRes.length">
              {{ $t('chooseprompt') }} :<br>
               <v-select
               	v-model="selectActionPrompt"
               	:items="computedActionUrl"
               	item-text="text"
               	item-value="id"
               	@change="actionsPrompt()"
               >
               </v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 md3>
                      <div class="search-block">
                        <v-text-field
                          v-model="searchName"
                          append-icon="search"
                          :label="$t('filtername')"
                          clearable
                        ></v-text-field>
                      </div>
                    </v-flex>
                    <v-flex xs12 md2 class="pl-2">
                      <v-btn
                        small
                        :color="showFilters ? 'primary' : ''"
                        :outline="!showFilters"
                        @click="showFilters = !showFilters"
                      >
                        {{ $t('filtersprompt') }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="showFilters" row wrap class="mb-3">
                    <v-flex xs12 md4>
                      <v-select
                        v-model="selectedAuthor"
                        :items="authorOptions"
                        :label="$t('filterauthor')"
                        clearable
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-select
                        v-model="selectedLlm"
                        :items="llmOptions"
                        :label="$t('filterllm')"
                        clearable
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-select
                        v-model="selectedDateRange"
                        :items="dateRangeOptions"
                        :label="$t('filterdate')"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="showFilters && selectedDateRange === 'calendar'" row wrap justify-end class="mb-3">
                    <v-flex xs12 md2>
                      <v-menu
                        v-model="showStartDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template slot="activator" slot-scope="{ on }">
                          <v-text-field
                            v-model="calendarStartDate"
                            :label="$t('filterstart')"
                            prepend-icon="event"
                            readonly
                            clearable
                            v-on="on"
                            @click:clear="calendarStartDate = ''"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="calendarStartDate"
                          @input="showStartDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 md2>
                      <v-menu
                        v-model="showEndDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template slot="activator" slot-scope="{ on }">
                          <v-text-field
                            v-model="calendarEndDate"
                            :label="$t('filterend')"
                            prepend-icon="event"
                            readonly
                            clearable
                            v-on="on"
                            @click:clear="calendarEndDate = ''"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="calendarEndDate"
                          @input="showEndDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <div class="table-scroll-area">
                    <v-data-table
                      :headers="headersFAQ"
                      :items="filteredPrompts"
                      :pagination.sync="tablePagination"
                      :must-sort="true"
                      item-key="index"
                      :loading="loadingData"
                      class="elevation-1"
                      :rows-per-page-items="[10, 25, 50]"
                    >
                      <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-xs-left date-col" :title="props.item.date || ''" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.date }}</td>
                          <td class="text-xs-left" :title="props.item.name || ''" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.name }}</td>
                          <td class="text-xs-left" :title="props.item.comment || ''" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.comment }}</td>
                          <td class="text-xs-left email-col" :title="props.item.who || ''" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.who }}</td>
                          <td class="text-xs-left llm-col" :title="props.item.llm || ''" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.llm }}</td>
                          <td class="text-xs-left short-num-col" :title="String(props.item.temperature || '')" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.temperature }}</td>
                          <td class="text-xs-left token-col" :title="String(props.item.tokens || '')" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.tokens }}</td>
                          <td class="text-xs-left truncate-text" :title="props.item.preview || ''" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.preview }}</td>
                          <td class="text-xs-right action-col">
                            <!-- Editer -->
                            <v-tooltip left >
                              <template slot="activator">
                                <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateFAQ(props.item)" >more_vert</v-icon>
                              </template>
                              <span>{{ $t('AIVoir') }}</span>
                            </v-tooltip>
                          </td>
                          <td class="text-xs-right action-col">
                            <v-tooltip left>
                              <template slot="activator">
                                <v-icon
                                  class="infos"
                                  color="black lighten-1"
                                  dark
                                  @click.stop="selectedPromptVersion = props.item; renamePromptName = (props.item && props.item.name) ? props.item.name : ''; renamePromptComment = (props.item && props.item.comment) ? props.item.comment : ''; showDialogRename = true"
                                >edit</v-icon>
                              </template>
                              <span>{{ $t('rename') }}</span>
                            </v-tooltip>
                          </td>
                          <td class="text-xs-right action-col">
                            <v-tooltip left>
                              <template slot="activator">
                                <v-icon
                                  :color="canDeleteVersion(props.item) ? 'black lighten-1' : 'grey lighten-1'"
                                  @click.stop="openConfirmDeleteDialogFromRow(props.item)"
                                >delete</v-icon>
                              </template>
                              <span>{{ canDeleteVersion(props.item) ? $t('delete') : $t('undeletable') }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>


        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && !modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn v-if="!loadingModifFAQ" flat @click="closeDialogConfirm()">{{ $t('no') }}</v-btn>
          <v-btn 
            :loading="loadingModifFAQ"
            :disabled="!selectActionPrompt.length"
            color="primary"
            @click="submitDialogConfirm()"
          >{{ $t('search') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialogConfirm')">{{ $t('close') }}</v-btn>
          <v-btn color="primary" @click="$emit('closeDialogConfirm')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialogConfirm()">{{ $t('close') }}</v-btn>
        </v-card-actions>
		
      <!-- dialog comparaison prompt actuel vs historique -->
      <v-dialog
        v-model="showDialogComparePrompt"
        persistent
        scrollable
        max-width="90%"
      >
        <v-card>
          <v-card-title class="primary white--text compare-title">
            <v-btn icon dark @click="closeCompareDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span class="title compare-title-text">{{ $t('compareprompt') }}</span>
          </v-card-title>
          <v-card-text class="compare-body">
            <div class="mb-3">
              <strong>{{ $t('sectionprompt') }}</strong> {{ selectedPromptField() }}
            </div>
            <v-layout row wrap>
              <v-flex xs12 md6 class="pr-3 compare-col">
                <h3 class="mb-2 compare-label">{{ $t('currentprompt') }}</h3>
                <v-textarea
                  :value="getCurrentPromptValue()"
                  readonly
                  auto-grow
                  rows="12"
                  outline
                ></v-textarea>
                <div class="compare-meta">
                  <div><strong>LLM:</strong> {{ getCurrentPromptMeta().llm }}</div>
                  <div><strong>{{ $t('Temperatureprompt') }}</strong> {{ getCurrentPromptMeta().temperature }}</div>
                  <div><strong>Tokens:</strong> {{ getCurrentPromptMeta().tokens }}</div>
                  <div><strong>{{ $t('Nameprompt') }}</strong> {{ getCurrentPromptMeta().name }}</div>
                  <div><strong>{{ $t('Commentprompt') }}</strong> {{ getCurrentPromptMeta().comment }}</div>
                </div>
              </v-flex>
              <v-flex xs12 md6 class="pl-3 compare-col">
                <h3 class="mb-2 compare-label">{{ $t('historyprompt') }}</h3>
                <v-textarea
                  :value="getHistoricPromptValue()"
                  readonly
                  auto-grow
                  rows="12"
                  outline
                ></v-textarea>
                <div class="compare-meta">
                  <div><strong>LLM:</strong> {{ getHistoricPromptMeta().llm }}</div>
                  <div><strong>{{ $t('Temperatureprompt') }}</strong> {{ getHistoricPromptMeta().temperature }}</div>
                  <div><strong>Tokens:</strong> {{ getHistoricPromptMeta().tokens }}</div>
                  <div><strong>{{ $t('Nameprompt') }}</strong> {{ getHistoricPromptMeta().name }}</div>
                  <div><strong>{{ $t('Commentprompt') }}</strong> {{ getHistoricPromptMeta().comment }}</div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn flat @click="closeCompareDialog">{{ $t('close') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              :disabled="!canDeleteSelectedVersion()"
              @click="openConfirmDeleteDialog"
            >
              {{ $t('deleteprompt') }}
            </v-btn>
            <v-btn
              color="warning"
              :disabled="selectedPromptField() === 'preview' || !selectedPromptVersion"
              @click="openConfirmRestoreDialog"
            >
               {{ $t('restoreprompt') }}
            </v-btn>
            <v-btn
              color="warning"
              outline
              :disabled="!selectedPromptVersion"
              @click="openConfirmRestoreDialog(true)"
            >
              Restaurer toutes les sections
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showDialogConfirmRestore"
        persistent
        max-width="560"
      >
        <v-card>
          <v-card-title class="headline">{{ $t('erasedprompt') }}</v-card-title>
          <v-card-text>
            <template v-if="restoreAllMode">
              Le prompt actuel (toutes les sections) sera remplacé par cette version historisée.
              <br>
              {{ $t('proceed') }}
            </template>
            <template v-else>
              {{ $t('actualprompt') }} <strong>{{ selectedPromptField() }}</strong> {{ $t('erasedprompt') }}.
              <br>
              {{ $t('proceed') }}
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogConfirmRestore = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="warning" @click="confirmRestorePrompt">{{ $t('confirm') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showDialogConfirmDelete"
        persistent
        max-width="560"
      >
        <v-card>
          <v-card-title class="headline">{{ $t('confirmation') }}</v-card-title>
          <v-card-text>
            {{ $t('definitlyprompt') }}
            <br>
            {{ $t('proceedprompt') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogConfirmDelete = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="error" :loading="loadingDeleteVersion" @click="confirmDeleteVersion">{{ $t('Delete') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showDialogRename"
        persistent
        max-width="560"
      >
        <v-card>
          <v-card-title class="headline">{{ $t('editcomment') }}</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="renamePromptName"
              :label=" $t('Name') "
              maxlength="255"
              counter
            ></v-text-field>
            <v-text-field
              v-model="renamePromptComment"
              :label=" $t('abscomment') "
              maxlength="255"
              counter
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogRename = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" :loading="loadingRenameVersion" @click="confirmRenameVersion">{{ $t('Submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
</template>

<script>
export default {
  props: {
    showDialogConfirmation: {
      type: Boolean,
      default: false
    },
    loadingModifFAQ: {
      type: Boolean,
      default: false
    },
    loadingRes: {
      type: Boolean,
      default: false
    },
    contentDialogConfirm: {
      type: String,
      default: ''
    },
    contentDialogRes: {
      type: String,
      default: ''
    },
    titleDialogConfirm: {
      type: String,
      default: 'Confirmation'
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    modifBaseCo: {
      type: Boolean,
      default: false
    },
    startLoading: {
      type: Number,
      default: 0
    },
    endLoading: {
      type: Number,
      default: 0
    },
    currentPromptData: {
      type: Object,
      default: () => ({})
    },
    sectionOptions: {
      type: Array,
      default: () => ([])
    },
    fetchUrl: {
      type: String,
      default: 'get/prompt_version.php'
    },
    renameUrl: {
      type: String,
      default: 'post/rename_prompt_version.php'
    },
    deleteUrl: {
      type: String,
      default: 'post/delete_prompt_version.php'
    },
    siteKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectActionPrompt: 'personality',
      checkboxMAJ: false,
      page: '',
      showDialogComparePrompt: false,
      showDialogConfirmRestore: false,
      restoreAllMode: false,
      showDialogConfirmDelete: false,
      showDialogRename: false,
      loadingDeleteVersion: false,
      loadingRenameVersion: false,
      renamePromptName: '',
      renamePromptComment: '',
      selectedPromptVersion: null,
      prompts: [],
      promptsOriginal: [],
      showFilters: false,
      selectedAuthor: '',
      selectedLlm: '',
      selectedDateRange: '',
      calendarStartDate: '',
      calendarEndDate: '',
      showStartDateMenu: false,
      showEndDateMenu: false,
      searchName: '',
      tablePagination: {
        sortBy: 'date_raw',
        descending: true,
        rowsPerPage: 10
      },
      headersFAQ: [
        { text: this.$t('dateprompt'), align: 'left', value: 'date_raw', width: '142px' },
        { text: this.$t('nameprompt'), align: 'left', value: 'name' },
        { text: this.$t('commentprompt'), align: 'left', value: 'comment' },
        { text: 'email', align: 'left', value: 'who', width: '160px' },
        { text: 'llm', align: 'left', value: 'llm', width: '124px' },
        { text: this.$t('temperatureprompt'), align: 'left', value: 'temperature', width: '78px' },
        { text: 'tokens', align: 'left', value: 'tokens', width: '84px' },
        { text: this.$t('previewprompt'), align: 'left', value: 'preview' },
        { text: '', align: 'right', value: 'update', sortable: false, width: '60px' },
        { text: '', align: 'right', value: 'rename', sortable: false, width: '70px' },
        { text: '', align: 'right', value: 'delete', sortable: false, width: '80px' }
      ],
      loadingData: true
    }
  },
  computed: {
    filteredPrompts () {
      const q = (this.searchName || '').toString().trim().toLowerCase()
      return this.prompts.filter(p => {
        const author = (p && p.who) ? String(p.who) : ''
        const matchesAuthor = !this.selectedAuthor || author === this.selectedAuthor
        if (!matchesAuthor) return false
        const llm = (p && p.llm) ? String(p.llm) : ''
        const matchesLlm = !this.selectedLlm || llm === this.selectedLlm
        if (!matchesLlm) return false
        const matchesDate = this.isDateInSelectedRange(p && p.date_raw ? p.date_raw : '')
        if (!matchesDate) return false
        if (!q.length) return true
        const name = (p && p.name) ? String(p.name).toLowerCase() : ''
        return name.includes(q)
      })
    },
    authorOptions () {
      const list = []
      const seen = {}
      this.promptsOriginal.forEach(p => {
        const email = (p && p.who) ? String(p.who).trim() : ''
        if (!email.length) return
        if (seen[email]) return
        seen[email] = true
        list.push(email)
      })
      return list
    },
    llmOptions () {
      const list = []
      const seen = {}
      this.promptsOriginal.forEach(p => {
        const llm = (p && p.llm) ? String(p.llm).trim() : ''
        if (!llm.length) return
        if (seen[llm]) return
        seen[llm] = true
        list.push(llm)
      })
      return list
    },
    dateRangeOptions () {
      return [
        { text: this.$t('todayprompt'), value: 'today' },
        { text: this.$t('7daysprompt'), value: '7d' },
        { text: this.$t('30daysprompt'), value: '30d' },
        { text: this.$t('3monthsprompt'), value: '3m' },
        { text: this.$t('calendarprompt'), value: 'calendar' }
      ]
    },
    computedActionUrl () {
      if (Array.isArray(this.sectionOptions) && this.sectionOptions.length) {
        return this.sectionOptions
      }
      let actions = [
        {text: this.$t('AIPersonnality'), id: 'personality'},
        {text: this.$t('AIEnviron'), id: 'environment'},
        {text: this.$t('AIObjective'), id: 'objectif'},
        {text: this.$t('AICommunication'), id: 'communication'},
        {text: this.$t('AIQuestion'), id: 'questions'},
        {text: this.$t('AIRules'), id: 'rules'},
        {text: this.$t('AITools'), id: 'tools'},
        {text: this.$t('AICustom'), id: 'custom'}
      ]
      return actions
    },
    loadingValue () {
      return Math.round((this.startLoading * 100) / this.endLoading)
    }
  },
  mounted () {
  },
  updated () {
  },
  created () {
    // recupère les données
    this.axios.get('get/prompt_version.php?sitekey=' + this.$store.state._Sites.siteSelected.LIC_KEY)
    .then(response => {
      const resAjx = this.normalizePromptRows(response.data)
      this.prompts = resAjx
      this.promptsOriginal = resAjx
      this.loadingData = false
    })
    .catch()
    .then(_ => {
      // this.loading = false
    })
  },
  methods: {
    closeDialogConfirm () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialogConfirm')
      } else {
        this.$emit('justCloseDialogConfirm')
      }
    },
    submitDialogConfirm () {
      this.$emit('submitDialogConfirm', this.selectActionPrompt, this.checkboxMAJ, this.page)
    },

    actionsPrompt () {
      if (!this.selectActionPrompt) return

      const field = this.selectActionPrompt // id choisi dans le v-select

      this.prompts = this.promptsOriginal.map(p => {
        return {
          ...p,
          preview: p[field] || '', // remplace "preview" par la valeur choisie
          tokens: p['tokens_' + field] || 0
        }
      })
    },

    openDialogUpdateFAQ (data) {
      this.selectedPromptVersion = data
      this.showDialogComparePrompt = true
    },
    closeCompareDialog () {
      this.showDialogComparePrompt = false
      this.selectedPromptVersion = null
      this.showDialogConfirmRestore = false
      this.restoreAllMode = false
      this.showDialogConfirmDelete = false
      this.showDialogRename = false
    },
    openConfirmRestoreDialog (restoreAll = false) {
      if (!this.selectedPromptVersion) return
      if (!restoreAll && this.selectedPromptField() === 'preview') return
      this.restoreAllMode = !!restoreAll
      this.showDialogConfirmRestore = true
    },
    confirmRestorePrompt () {
      if (this.restoreAllMode) {
        const sections = this.getHistoricPromptSections()
        this.$emit('restoreAllPromptSections', sections)
      } else {
        const field = this.selectedPromptField()
        const value = this.getHistoricPromptValue()
        this.$emit('restorePromptSection', field, value)
      }
      this.showDialogConfirmRestore = false
      this.restoreAllMode = false
      this.closeCompareDialog()
    },
    getHistoricPromptSections () {
      if (!this.selectedPromptVersion) {
        return {
          personality: '',
          environment: '',
          objectif: '',
          communication: '',
          questions: '',
          rules: '',
          tools: '',
          custom: ''
        }
      }
      return {
        personality: this.selectedPromptVersion.personality || '',
        environment: this.selectedPromptVersion.environment || '',
        objectif: this.selectedPromptVersion.objectif || '',
        communication: this.selectedPromptVersion.communication || '',
        questions: this.selectedPromptVersion.questions || '',
        rules: this.selectedPromptVersion.rules || '',
        tools: this.selectedPromptVersion.tools || '',
        custom: this.selectedPromptVersion.custom || ''
      }
    },
    canDeleteSelectedVersion () {
      if (!this.selectedPromptVersion) return false
      return String(this.selectedPromptVersion.is_backup) === '1'
    },
    canDeleteVersion (item) {
      if (!item) return false
      return String(item.is_backup) === '1'
    },
    openConfirmDeleteDialogFromRow (item) {
      if (!this.canDeleteVersion(item)) return
      this.selectedPromptVersion = item
      this.showDialogConfirmDelete = true
    },
    openConfirmDeleteDialog () {
      if (!this.canDeleteSelectedVersion()) return
      this.showDialogConfirmDelete = true
    },
    openRenameDialogFromRow (item) {
      this.selectedPromptVersion = item
      this.renamePromptName = item && item.name ? item.name : ''
      this.renamePromptComment = item && item.comment ? item.comment : ''
      this.showDialogRename = true
    },
    confirmRenameVersion () {
      if (!this.selectedPromptVersion) return

      const dataToPost = new window.FormData()
      dataToPost.append('sitekey', this.$store.state._Sites.siteSelected.LIC_KEY)
      dataToPost.append('prompt_date_raw', this.selectedPromptVersion.date_raw || '')
      dataToPost.append('prompt_user_id', this.selectedPromptVersion.user || '')
      dataToPost.append('prompt_isbackup', this.selectedPromptVersion.is_backup)
      dataToPost.append('prompt_name', this.renamePromptName || '')
      dataToPost.append('prompt_comment', this.renamePromptComment || '')

      this.loadingRenameVersion = true
      this.axios.post('post/rename_prompt_version.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(() => {
        this.showDialogRename = false
        return this.axios.get('get/prompt_version.php?sitekey=' + this.$store.state._Sites.siteSelected.LIC_KEY)
      })
      .then(response => {
        if (!response) return
        const resAjx = this.normalizePromptRows(response.data)
        this.prompts = resAjx
        this.promptsOriginal = resAjx
      })
      .catch(() => {})
      .then(() => {
        this.loadingRenameVersion = false
      })
    },
    confirmDeleteVersion () {
      if (!this.selectedPromptVersion) return

      const dataToPost = new window.FormData()
      dataToPost.append('sitekey', this.$store.state._Sites.siteSelected.LIC_KEY)
      dataToPost.append('prompt_date_raw', this.selectedPromptVersion.date_raw || '')
      dataToPost.append('prompt_user_id', this.selectedPromptVersion.user || '')
      dataToPost.append('prompt_isbackup', this.selectedPromptVersion.is_backup)

      this.loadingDeleteVersion = true
      this.axios.post('post/delete_prompt_version.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(() => {
        this.showDialogConfirmDelete = false
        this.closeCompareDialog()
        return this.axios.get('get/prompt_version.php?sitekey=' + this.$store.state._Sites.siteSelected.LIC_KEY)
      })
      .then(response => {
        if (!response) return
        const resAjx = this.normalizePromptRows(response.data)
        this.prompts = resAjx
        this.promptsOriginal = resAjx
      })
      .catch(() => {})
      .then(() => {
        this.loadingDeleteVersion = false
      })
    },
    selectedPromptField () {
      if (typeof this.selectActionPrompt === 'string' && this.selectActionPrompt.length) {
        return this.selectActionPrompt
      }
      return 'preview'
    },
    getCurrentPromptValue () {
      const field = this.selectedPromptField()
      if (!this.currentPromptData) return ''
      return this.currentPromptData[field] || ''
    },
    getHistoricPromptValue () {
      const field = this.selectedPromptField()
      if (!this.selectedPromptVersion) return ''
      return this.selectedPromptVersion[field] || this.selectedPromptVersion.preview || ''
    },
    estimatePromptTokens (text) {
      const value = (text || '').toString().trim()
      if (!value.length) return 0
      const normalized = value.replace(/\s+/g, ' ').trim()
      const charCount = normalized.length
      const words = normalized.match(/[A-Za-z0-9_\u00C0-\u017F]+/g) || []
      const punct = normalized.match(/[^\w\s]/g) || []
      const estimateByChars = Math.ceil(charCount / 4)
      const estimateByWordMix = Math.ceil((words.length * 1.3) + (punct.length * 0.2))
      return Math.max(estimateByChars, estimateByWordMix, 1)
    },
    getCurrentPromptMeta () {
      const value = this.getCurrentPromptValue()
      return {
        llm: (this.currentPromptData && this.currentPromptData.llm) ? this.currentPromptData.llm : '-',
        temperature: (this.currentPromptData && this.currentPromptData.temperature !== undefined && this.currentPromptData.temperature !== null && this.currentPromptData.temperature !== '') ? this.currentPromptData.temperature : '-',
        tokens: this.estimatePromptTokens(value),
        name: (this.currentPromptData && this.currentPromptData.name) ? this.currentPromptData.name : '-',
        comment: (this.currentPromptData && this.currentPromptData.comment) ? this.currentPromptData.comment : ((this.currentPromptData && this.currentPromptData.name) ? this.currentPromptData.name : '-')
      }
    },
    getHistoricPromptMeta () {
      if (!this.selectedPromptVersion) {
        return { llm: '-', temperature: '-', tokens: 0, name: '-', comment: '-' }
      }
      const field = this.selectedPromptField()
      const tokenKey = 'tokens_' + field
      return {
        llm: this.selectedPromptVersion.llm || '-',
        temperature: (this.selectedPromptVersion.temperature !== undefined && this.selectedPromptVersion.temperature !== null && this.selectedPromptVersion.temperature !== '') ? this.selectedPromptVersion.temperature : '-',
        tokens: this.selectedPromptVersion[tokenKey] || this.selectedPromptVersion.tokens || this.estimatePromptTokens(this.getHistoricPromptValue()),
        name: this.selectedPromptVersion.name || '-',
        comment: this.selectedPromptVersion.comment || '-'
      }
    },
    parsePromptDate (dateRaw) {
      if (!dateRaw) return null
      const normalized = String(dateRaw).replace(' ', 'T')
      const d = new Date(normalized)
      if (isNaN(d.getTime())) return null
      return d
    },
    isDateInSelectedRange (dateRaw) {
      if (!this.selectedDateRange) return true
      const d = this.parsePromptDate(dateRaw)
      if (!d) return false

      const now = new Date()
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
      const tomorrowStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0)

      if (this.selectedDateRange === 'calendar') {
        const hasStart = !!this.calendarStartDate
        const hasEnd = !!this.calendarEndDate
        if (!hasStart && !hasEnd) return true

        let startDate = null
        let endDateExclusive = null

        if (hasStart) {
          const s = new Date(this.calendarStartDate + 'T00:00:00')
          if (!isNaN(s.getTime())) startDate = s
        }
        if (hasEnd) {
          const e = new Date(this.calendarEndDate + 'T00:00:00')
          if (!isNaN(e.getTime())) {
            e.setDate(e.getDate() + 1)
            endDateExclusive = e
          }
        }

        if (startDate && endDateExclusive && startDate > endDateExclusive) return false
        if (startDate && d < startDate) return false
        if (endDateExclusive && d >= endDateExclusive) return false
        return true
      }

      if (this.selectedDateRange === 'today') {
        return d >= todayStart && d < tomorrowStart
      }

      if (this.selectedDateRange === '7d') {
        const from = new Date(todayStart)
        from.setDate(from.getDate() - 6)
        return d >= from && d < tomorrowStart
      }

      if (this.selectedDateRange === '30d') {
        const from = new Date(todayStart)
        from.setDate(from.getDate() - 29)
        return d >= from && d < tomorrowStart
      }

      if (this.selectedDateRange === '3m') {
        const from = new Date(todayStart)
        from.setMonth(from.getMonth() - 3)
        return d >= from && d < tomorrowStart
      }

      return true
    },
    normalizePromptRows (rows) {
      if (!Array.isArray(rows)) return []
      return rows.map(item => {
        if (!item || typeof item !== 'object') return item
        const whoValue = (item.who !== undefined && item.who !== null) ? String(item.who).trim() : ''
        if (whoValue.toLowerCase().includes('chucknorris')) {
          return {
            ...item,
            who: 'Super-Admin@ringover.com'
          }
        }
        return item
      })
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .tf_loading_url {
    height: 400px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .tf_text_url {
    height: 400px;
    display: flex;
    flex-direction: column;
  }
  .contentLoading {
    padding-top: 20px;
  }
  .v-progress-circular {
    margin: 1rem;
  }
  .v-progress-circular__overlay {
    stroke: currentColor;
    z-index: 2;
    transition: all 0.6s ease-in-out;
  }
  .tf_contentLoading{
    height: 100%;
    width: 100%;
  }

  .contentLoading {
    height: 100%;
    padding-bottom: 20px;
  }
  .tf_contentLoading h3 {
    text-align: left;
  }
  .loadingNum {
    text-align: center;
  }
  .tf_contentLoading .listeUrlsError {
    text-align: left;
  }
  .tf_contentLoading .listeUrlsError li {
    font-weight: 500;
  }
  .truncate-text {
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .compare-col {
    margin-bottom: 12px;
  }
  .compare-body {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .compare-body .layout {
    margin-left: 0;
    margin-right: 0;
  }
  .compare-body .flex {
    padding-left: 0;
    padding-right: 0;
  }
  .compare-label {
    margin-left: 0;
  }
  .compare-meta {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.4;
    color: #37474f;
  }
  .compare-title {
    align-items: center;
  }
  .compare-title-text {
    line-height: 1.2;
  }
  .table-scroll-area {
    max-height: 55vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .search-block {
    background: #fff;
  }
  .action-col {
    width: 56px;
    max-width: 56px;
    padding-left: 4px !important;
    padding-right: 4px !important;
    white-space: nowrap;
  }
  .table-scroll-area /deep/ table {
    table-layout: fixed;
  }
  .table-scroll-area /deep/ th:nth-last-child(-n+3),
  .table-scroll-area /deep/ td:nth-last-child(-n+3) {
    width: 44px !important;
    max-width: 44px !important;
    min-width: 44px !important;
    padding-left: 2px !important;
    padding-right: 2px !important;
    white-space: nowrap !important;
  }
  .short-num-col {
    width: 64px;
    max-width: 64px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .token-col {
    width: 84px;
    max-width: 84px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .llm-col {
    width: 124px;
    max-width: 124px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .date-col {
    width: 142px;
    max-width: 142px;
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
    line-height: 1.2;
    word-break: break-word;
  }
  .email-col {
    width: 160px;
    max-width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogVersionPrompt.vue